module.exports = __webpack_public_path__ + "static/media/google_search.0e84aa3c.svg";